import { createFileRoute } from '@tanstack/react-router'
import ContactConcepts from 'Contact/components/Contact/Sections/ContactConcepts'

export const Route = createFileRoute('/contact/$contactId/concepts')({
    component: ContactConcepts,
})
